module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-8-3cc1ec0289b22b605bdfa79d69bdf768.png";